// recency — turn a signal's ISO `occurred_at` into operator-readable labels so
// it's always obvious whether an event is happening now or is historical, and
// exactly when it's from. Used by the map detail card (and re-usable by the
// list/timeline). Pure; `nowMs` is injectable for tests.

export interface Recency {
  /** "just now" | "12m ago" | "3h ago" | "2d ago" | "upcoming" | "—" */
  relative: string;
  /** "2026-06-04 00:00 UTC" */
  absolute: string;
  /** Happened within the last hour — render a LIVE tag. */
  isLive: boolean;
  /** Older than ~24h — render a PAST tag. */
  isPast: boolean;
}

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

export function formatRecency(iso: string, nowMs: number = Date.now()): Recency {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) {
    return { relative: '—', absolute: iso, isLive: false, isPast: false };
  }
  const age = nowMs - t;
  const min = age / 60_000;
  const hr = age / 3_600_000;
  const day = hr / 24;

  let relative: string;
  if (age < 0) relative = 'upcoming';
  else if (min < 1) relative = 'just now';
  else if (min < 60) relative = `${Math.round(min)}m ago`;
  else if (hr < 48) relative = `${Math.round(hr)}h ago`;
  else relative = `${Math.round(day)}d ago`;

  const d = new Date(t);
  const absolute =
    `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ` +
    `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} UTC`;

  return { relative, absolute, isLive: age >= 0 && hr < 1, isPast: hr >= 24 };
}
